import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconSettings12(props: SvgIconProps) {
  return (
    <SVGIcon width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.53544 5.5H0V6.5H2.53544C2.51209 6.3367 2.5 6.16976 2.5 6C2.5 5.83024 2.51209 5.6633 2.53544 5.5ZM3.19681 3.90391C3.39756 3.63587 3.63587 3.39756 3.90391 3.19681L2.11091 1.4038L1.4038 2.11091L3.19681 3.90391ZM5.5 2.53544C5.6633 2.51209 5.83024 2.5 6 2.5C6.16976 2.5 6.3367 2.51209 6.5 2.53544V0H5.5V2.53544ZM8.09608 3.19681C8.36413 3.39756 8.60244 3.63587 8.80319 3.90391L10.5962 2.11092L9.88908 1.40381L8.09608 3.19681ZM9.46456 5.5C9.48791 5.6633 9.5 5.83024 9.5 6C9.5 6.16976 9.48791 6.3367 9.46456 6.5H12V5.5H9.46456ZM8.80319 8.09609C8.60244 8.36413 8.36413 8.60244 8.09609 8.80319L9.88908 10.5962L10.5962 9.88908L8.80319 8.09609ZM6.5 9.46456C6.3367 9.48791 6.16976 9.5 6 9.5C5.83024 9.5 5.6633 9.48791 5.5 9.46456V12H6.5V9.46456ZM3.90391 8.80319C3.63587 8.60244 3.39756 8.36413 3.19681 8.09609L1.4038 9.88909L2.11091 10.5962L3.90391 8.80319Z"
        fill="#616161"
      />
      <circle cx="6" cy="6" r="3.5" stroke="currentColor" />
    </SVGIcon>
  );
}
